export const CountryCodes = { SPAIN: 'ES', FRANCE: 'FR' };
